import React from 'react';
import styled from 'styled-components';
import { NONE } from '../../../constants/constants';
import FlexBox from '../flexbox/FlexBox';
import { DocumentSortOptionsEnum } from '../../../features/documents/types/types';

const Label = styled.label`
  color: var(--color-deep-gray);
  font-size: var(--font-size-600);
  font-weight: 600;
`;

const SelectInput = styled.select`
  height: 36px;
  padding: 4px;
  border: 1px solid var(--color-dark-gray);
  border-radius: 4px;
  background-color: var(--color-oxford-blue);
  color: var(--color-deep-gray);
  font-size: var(--font-size-600);
`;

const Option = styled.option`
  padding: 5px;
`;

interface SelectProps {
  label?: string;
  options: { value: string | number; label: string }[];
  value: string | DocumentSortOptionsEnum;
  onChange: (value: string | DocumentSortOptionsEnum) => void;
  placeholder?: string;
  disablePlaceholder?: boolean;
  disabled?: boolean;
}

const Select: React.FC<SelectProps> = ({
  label,
  options,
  value,
  onChange,
  placeholder,
  disablePlaceholder = false,
  disabled = false
}) => {
  return (
    <FlexBox $direction="column">
      {label && <Label>{label}</Label>}
      <SelectInput value={value} onChange={(e) => onChange(e.target.value)} disabled={disabled}>
        {placeholder && (
          <Option value={NONE} disabled={disablePlaceholder}>
            {placeholder}
          </Option>
        )}
        {options.map(({ value, label }) => (
          <Option key={value} value={value}>
            {label}
          </Option>
        ))}
      </SelectInput>
    </FlexBox>
  );
};

export default Select;
